import {
  LayoutDashboard,
  Component,
  Settings,
  Users,
  ShieldCheck,
  Building2,
  Network,
  Sparkles,
  ClipboardList,
  ClipboardSignature,
  Target,
  Leaf,
  BarChart2,
  FileText,
  BookOpen,
} from "lucide-react";
import { PATHS } from "@/lib/router";

export const NAVIGATION_SECTIONS = {
  OVERVIEW: "navigation.overview",
  DATA: "navigation.data",
  MANAGEMENT: "navigation.management",
};

const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const navigationItems = [
  {
    label: "navigation.dashboard",
    icon: LayoutDashboard,
    link: PATHS.DASHBOARD,
    section: NAVIGATION_SECTIONS.OVERVIEW,
  },
  {
    label: "navigation.organization",
    icon: Network,
    link: PATHS.ORGANIZATION,
    section: NAVIGATION_SECTIONS.OVERVIEW,
  },
  ...(isLocalhost
    ? [
        {
          label: "Components",
          icon: Component,
          link: PATHS.COMPONENTS,
          section: NAVIGATION_SECTIONS.OVERVIEW,
        },
      ]
    : []),
  {
    label: "navigation.esg",
    icon: Leaf,
    section: NAVIGATION_SECTIONS.DATA,
    subItems: [
      {
        label: "navigation.esgDashboard",
        icon: BarChart2,
        link: PATHS.ESG_DASHBOARD,
      },
      {
        label: "navigation.targetSettings",
        icon: Target,
        link: PATHS.ESG_TARGETS,
      },
      {
        label: "navigation.esgReports",
        icon: FileText,
        link: PATHS.ESG_REPORTS,
      },
      {
        label: "navigation.customDisclosures",
        icon: BookOpen,
        link: PATHS.ESG_CUSTOM_DISCLOSURES,
      },
      {
        label: "navigation.moreSolutions",
        icon: Sparkles,
        link: PATHS.MORE_SOLUTIONS,
      },
    ],
  },
  {
    label: "navigation.surveys",
    icon: ClipboardSignature,
    link: PATHS.SURVEYS,
    section: NAVIGATION_SECTIONS.DATA,
  },
  {
    label: "navigation.settings",
    icon: Settings,
    link: PATHS.SETTINGS,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
  },
  {
    label: "navigation.userManagementSection",
    icon: Users,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
    subItems: [
      {
        label: "navigation.rolesAndPermissions",
        icon: ShieldCheck,
        link: PATHS.ROLES_PERMISSIONS,
      },
      {
        label: "navigation.users",
        icon: Users,
        link: PATHS.USER_LIST,
      },
    ],
  },
  {
    label: "navigation.activityLog",
    icon: ClipboardList,
    link: PATHS.ACTIVITY_LOG,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
  },
];
